import { useState, useMemo } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Col, Tooltip } from "reactstrap";
import RawComponent from "../RawHTML";
import VideoPlayer from "../Player/VideoPlayer";

const Example = ({
  title,
  type,
  content,
  children,
  buttonLabel,
  buttonSize,
  size,
  messageTooltip,
}) => {
  const [modal, setModal] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  // biar id tooltip ga tabrakan kalau modalnya banyak
  const tooltipId = useMemo(
    () => `Tooltip-${Math.random().toString(36).slice(2)}`,
    []
  );

  const toggleTooltip = () => setTooltipOpen((v) => !v);
  const toggle = () => setModal((v) => !v);

  return (
    <div>
      <Button color="primary" onClick={toggle} size={buttonSize} id={tooltipId}>
        {buttonLabel}
      </Button>

      {!!messageTooltip && (
        <Tooltip placement="top" isOpen={tooltipOpen} target={tooltipId} toggle={toggleTooltip}>
          {messageTooltip}
        </Tooltip>
      )}

      <Modal isOpen={modal} toggle={toggle} size={size}>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>

        <ModalBody>
          {type === "video" && (
            <Col sm="12" className="mb-3 text-center d-flex justify-content-center">
              <VideoPlayer link={content} width={720} />
            </Col>
          )}

          {type === "html" && <RawComponent htmlContent={content} />}

          {type === "text" && <p>{content}</p>}

          {type === "image" && (
            <Col sm="12" className="mb-3 text-center d-flex justify-content-center">
              <img
                src={content}
                alt={title}
                className="img-fluid"
                style={{
                  borderRadius: "10px",
                  width: "auto",
                  height: "auto",
                  objectFit: "cover",
                }}
              />
            </Col>
          )}

          {/* ✅ INI yang kamu butuhin */}
          {type === "component" && (content || children)}

          {/* optional fallback kalau lupa set type */}
          {!type && (content || children)}
        </ModalBody>

        <ModalFooter>
          <Button color="warning" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Example;